export const LOGOUT_USER = 'LOGOUT_USER'
export const LOGIN_USER = 'LOGIN_USER'

export const UPDATE_GDPR = 'UPDATE_GDPR'

export const NOTIFICATION_DISPATCH = 'NOTIFICATION_DISPATCH'
export const NOTIFICATION_CLOSE = 'NOTIFICATION_CLOSE'

export const SET_LANGUAGES = 'SET_LANGUAGES'

export const SET_CONTRACT = 'SET_CONTRACT'

export const SET_PAYMENT_PLANS = 'SET_PAYMENT_PLANS'

export const SET_AGENCY = 'SET_AGENCY'

export const SET_AGENT = 'SET_AGENT'
